/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisqualifyTeamBody
 */
export interface DisqualifyTeamBody {
    /**
     * Reason for disqualification
     * @type {string}
     * @memberof DisqualifyTeamBody
     */
    reason: string;
    /**
     * Whether to forfeit any active matches (default true)
     * @type {boolean}
     * @memberof DisqualifyTeamBody
     */
    forfeitActiveMatches?: boolean;
    /**
     * Whether to issue a refund for entry fee
     * @type {boolean}
     * @memberof DisqualifyTeamBody
     */
    issueRefund?: boolean;
    /**
     * Percentage of entry fee to refund (0-100, default 0)
     * @type {number}
     * @memberof DisqualifyTeamBody
     */
    refundPercentage?: number;
}

/**
 * Check if a given object implements the DisqualifyTeamBody interface.
 */
export function instanceOfDisqualifyTeamBody(value: object): value is DisqualifyTeamBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DisqualifyTeamBodyFromJSON(json: any): DisqualifyTeamBody {
    return DisqualifyTeamBodyFromJSONTyped(json, false);
}

export function DisqualifyTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisqualifyTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'forfeitActiveMatches': json['forfeitActiveMatches'] == null ? undefined : json['forfeitActiveMatches'],
        'issueRefund': json['issueRefund'] == null ? undefined : json['issueRefund'],
        'refundPercentage': json['refundPercentage'] == null ? undefined : json['refundPercentage'],
    };
}

export function DisqualifyTeamBodyToJSON(json: any): DisqualifyTeamBody {
    return DisqualifyTeamBodyToJSONTyped(json, false);
}

export function DisqualifyTeamBodyToJSONTyped(value?: DisqualifyTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'forfeitActiveMatches': value['forfeitActiveMatches'],
        'issueRefund': value['issueRefund'],
        'refundPercentage': value['refundPercentage'],
    };
}

